<template>
  <b-container class="tours-control-monitor" fluid>
    <div style="position: relative; max-height: 100vh;" id="monitor" :class="viewType === 'tv' ? 'overflow-hidden' : 'overflow-auto'">
      <div id="inner-monitor" style="position:relative">
        <b-row>
          <b-col class="align-self-center py-1">
            <h5>
              <span v-translate="{countdown}">Tours Monitor <small>(Autorefresh in %{countdown}s)</small></span>
              <b-link size="sm" class="p-0" v-b-modal.modalConfigMonitor><font-awesome-icon size="sm" icon="cog" /></b-link>
              <b-spinner small v-if="working" /></h5>
          </b-col>
          <b-modal size="sm" id="modalConfigMonitor" ref="modalConfigMonitor" hide-footer hide-header>
            <b-row>
              <b-col class="text-center">
                <b-button-group size="lg">
                  <b-button @click.prevent="viewType = 'tv'; setIntervalChangeScreen(); $refs.modalConfigMonitor.hide();" :disabled="viewType === 'tv'"><font-awesome-icon size="sm" icon="tv" /></b-button>
                  <b-button @click.prevent="viewType = 'list'; if(screenScroller) screenScroller.stop(); screenScroller = null; $refs.modalConfigMonitor.hide();" :disabled="viewType === 'list'"><font-awesome-icon size="sm" icon="list" /></b-button>
                  <b-button @click.prevent="viewType = 'grid'; if(screenScroller) screenScroller.stop(); screenScroller = null;  $refs.modalConfigMonitor.hide();" :disabled="viewType === 'grid'"><font-awesome-icon size="sm" icon="th" /></b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </b-modal>
          <b-col class="align-self-center py-1">
            <div v-if="warehousesSelect.length > 0">
              <b-form-group class="mb-1">
                <b-form-select size="sm" v-model="filterWarehouse" :options="countryOverride ? warehousesSelect : []">
                  <template slot="first">
                    <option :value="null" v-translate>None</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </div>
          </b-col>
          <b-col class="align-self-center">
            <b-form-group class="mb-1">
              <b-form-select size="sm" v-model="countryOverride" :options="window.countries.map(x => { return {value: x.iso_code, text: x.name} })" @change="setNewCountry" v-if="isInternational">
                <template slot="first">
                  <option :value="null" v-translate>Select Country</option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-alert variant="warning" :show="connectionError">
          <span v-translate="{countdownConnectionError}">There are connection errors. Retrying in %{countdownConnectionError}s.</span>
        </b-alert>

        <b-alert variant="warning" class="my-3" show v-if="!countryOverride || !filterWarehouse">
          <h4 class="my-0" v-translate>You need to set a Country and the Country must have warehouses set.</h4>
        </b-alert>
        <b-row id="data">
          <b-col cols="12" v-for="(tour, i) in tours" :key="tour.id + i" v-if="viewType === 'list' && countryOverride && tours.length > 0">
            <b-card class="mb-1 p-0" :class="rowBg(tour)">
              <b-row class="p-0">
                <b-col cols="2">
                  <b-row>
                    <b-col>
                      <small><strong>{{tour.visualStatus.toUpperCase()}}</strong>
                      <b-link :to="{ name: 'viewTour', params: {id: tour.id} }" target="_blank" class="text-secondary">#{{tour.id | uuid}}</b-link></small>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <div v-if="tour.status === 'READY' && tour.courier">
                    <small v-if="tour.distanceToDestination">{{tour.readableDistanceToDestination}}<strong><br>{{tour.eta}}</strong></small>
                    <span class="text-danger" v-else>
                      <small v-translate>No tracking</small>
                    </span>
                  </div>
                  <!-- <div v-else>{{tour.timeSinceStartRaw}} / {{ tour.completedRatio }} * {{ tour.shippingsQty }} = {{tour.order}}</div> -->
                </b-col>
                <b-col cols="4">
                  <div v-if="tour.courier">
                    <small>#{{tour.courier.id}} <strong>{{tour.courier.name}}</strong>
                    <span v-if="tour.status !== 'FINISHED'"><br>{{tour.courier.phone | phone('ar')}}</span></small>
                  </div>
                </b-col>
                <b-col>
                  <small v-translate="{qty: tour.shippingsQty}">%{qty} shippings</small>
                </b-col>
                <b-col cols="2">
                  <div>
                    <b-badge class="mr-1" variant="light" v-for="(item, index) in tour.sizes" :key="index">
                      {{index}}
                      <small>{{item}}</small>
                    </b-badge>
                  </div>
                </b-col>
                <b-col cols="2" md="1">
                  <small>{{tour.visits4Show.filter(x => x.visited === 1).length}}/{{tour.visits4Show.length}} ({{ tour.completedPercentage }})</small>
                  <div v-if="tour.timeSinceStart"><small>{{ tour.timeSinceStart }}</small></div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="4" v-for="(tour, i) in tours" :key="tour.id + i" v-if="viewType === 'grid' && countryOverride && tours.length > 0">
            <b-card class="mb-1 p-0" :class="rowBg(tour)">
              <b-row class="p-0">
                <b-col cols="4">
                  <small><strong>{{tour.visualStatus.toUpperCase()}}</strong></small>
                </b-col>
                <b-col cols="4">
                  <small><b-link :to="{ name: 'viewTour', params: {id: tour.id} }" target="_blank" class="text-secondary">#{{tour.id | uuid}}</b-link></small>
                </b-col>
                <b-col cols="4">
                  <div v-if="tour.status === 'READY' && tour.courier">
                    <small v-if="tour.distanceToDestination">{{tour.readableDistanceToDestination}}/<strong>{{tour.eta}}</strong></small>
                    <span class="text-danger" v-else>
                      <small v-translate>No tracking</small>
                    </span>
                  </div>
                </b-col>
                <b-col cols="12">
                  <div v-if="tour.courier">
                    <small>#{{tour.courier.id}} <strong>{{tour.courier.name}}</strong>
                    <span v-if="tour.status !== 'FINISHED'"><br>{{tour.courier.phone | phone('ar')}}</span></small>
                  </div>
                </b-col>
                <b-col cols="4">
                  <small v-translate="{qty: tour.shippingsQty}">%{qty} shippings</small>
                </b-col>
                <b-col cols="8">
                  <small>{{tour.visits4Show.filter(x => x.visited === 1).length}}/{{tour.visits4Show.length}} ({{ tour.completedPercentage }})</small>
                  <span v-if="tour.timeSinceStart"><small>{{ tour.timeSinceStart }}</small></span>
                </b-col>
                <b-col cols="12">
                  <div>
                    <b-badge class="mr-1" variant="light" v-for="(item, index) in tour.sizes" :key="index">
                      {{index}}
                      <small>{{item}}</small>
                    </b-badge>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" :class="i === currentScreen ? 'd-block' : 'd-none'" v-for="(status, i) in statuses" :key="status" v-if="viewType === 'tv' && countryOverride && tours.length > 0">
            <b-row>
              <b-col cols="4" v-for="(tour, i) in tours.filter(x => x.visualStatus === status)" :key="tour.id + i" v-if="tours.filter(x => x.visualStatus === status).length > 0">
                <b-card class="mb-1 p-0" :class="rowBg(tour)">
                  <b-row class="p-0">
                    <b-col cols="4">
                      <small><strong>{{tour.visualStatus.toUpperCase()}}</strong></small>
                    </b-col>
                    <b-col cols="4">
                      <small>#{{tour.id | uuid}}</small>
                    </b-col>
                    <b-col cols="4">
                      <div v-if="tour.status === 'READY' && tour.courier">
                        <small v-if="tour.distanceToDestination">{{tour.readableDistanceToDestination}}/<strong>{{tour.eta}}</strong></small>
                        <span class="text-danger" v-else>
                          <small v-translate>No tracking</small>
                        </span>
                      </div>
                    </b-col>
                    <b-col cols="12">
                      <div v-if="tour.courier">
                        <small>#{{tour.courier.id}} <strong>{{tour.courier.name}}</strong>
                        <span v-if="tour.status !== 'FINISHED'"><br>{{tour.courier.phone | phone('ar')}}</span></small>
                      </div>
                    </b-col>
                    <b-col cols="4">
                      <small v-translate="{qty: tour.shippingsQty}">%{qty} shippings</small>
                    </b-col>
                    <b-col cols="8">
                      <small>{{tour.visits4Show.filter(x => x.visited === 1).length}}/{{tour.visits4Show.length}} ({{ tour.completedPercentage }})</small>
                      <span v-if="tour.timeSinceStart"><small>{{ tour.timeSinceStart }}</small></span>
                    </b-col>
                    <b-col cols="12">
                      <div>
                        <b-badge class="mr-1" variant="light" v-for="(item, index) in tour.sizes" :key="index">
                          {{index}}
                          <small>{{item}}</small>
                        </b-badge>
                      </div>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col cols="12" class="text-center mt-3" v-if="tours.filter(x => x.visualStatus === status).length === 0">
                <h6 v-translate="{status: status.toUpperCase()}">No %{status} tours</h6>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>

<script>
import AddressMixins from '@/mixins/address.mixin.js'
import Zenscroll from 'zenscroll'

export default {
  name: 'whEntryMonitor',
  data() {
    return {
      tours: [],
      filterWarehouse: null,
      filterWarehouseArea: null,
      warehouses: [],
      window: window,
      countryOverride: null,
      averageSpeed: 35,
      timeout: null,
      intervalCountdown: null,
      countdown: 60,
      connectionError: false,
      intervalConnectionError: null,
      countdownConnectionError: 10,
      working: false,
      fetches: {},
      statuses: [],
      viewType: 'tv',
      countdownChangeScreen: 20,
      intervalChangeScreen: null,
      currentScreen: 0,
      screenScroller: null
    }
  },
  watch: {
    filterWarehouse(val) {
      if (val && this.countryOverride) {
        this.getTours()
      } else {
        this.clearTimeout()
        this.tours = []
      }
    },
    countryOverride(val) {
      if (val) {
        this.getTours()
      } else {
        this.clearTimeout()
        this.tours = []
      }
    }
  },
  mixins: [AddressMixins],
  created() {
    this.fetchWarehouses()
  },
  mounted() {
    this.countryOverride = this.$cookies.get('country') && !this.$cookies.get('bypassCountry') ? this.$cookies.get('country') : null
    this.warehouses = this.warehousesSelect
    this.filterWarehouse = this.$cookies.get('warehouse') || null
    this.getTours()
    this.setIntervalChangeScreen()
  },
  methods: {
    setIntervalChangeScreen() {
      if (this.viewType === 'tv') {
        this.countdownChangeScreen = this.tours.filter(x => x.visualStatus === this.statuses[this.currentScreen]).length * 2
        this.countdownChangeScreen = this.countdownChangeScreen > 30 ? 30 : (this.countdownChangeScreen === 0 ? 3 : (this.countdownChangeScreen < 10 ? 10 : this.countdownChangeScreen))
        this.intervalChangeScreen = setTimeout(function () {
          this.screenScroller = null
          this.currentScreen = this.currentScreen === 4 ? 0 : this.currentScreen + 1
          this.$nextTick(() => {
            if (!this.isInViewport(document.getElementById('inner-monitor'))) {
              this.scrollDown()
            }
          })
          this.setIntervalChangeScreen()
        }.bind(this), this.countdownChangeScreen * 1000)
      } else {
        clearTimeout(this.intervalChangeScreen)
        this.screenScroller = this.screenScroller ? this.screenScroller.stop() : null
      }
    },
    scrollDown() {
      this.screenScroller = Zenscroll.createScroller(document.getElementById('monitor'), this.countdownChangeScreen / 2 * 1000, 50)
      this.screenScroller.toY(document.querySelector('#inner-monitor').offsetHeight - window.innerHeight, this.countdownChangeScreen / 2 * 1000, () => { this.scrollUp() })
    },
    scrollUp() {
      this.screenScroller = Zenscroll.createScroller(document.getElementById('monitor'), this.countdownChangeScreen / 2 * 1000, 50)
      this.screenScroller.to(document.getElementById('monitor'), this.countdownChangeScreen / 2 * 1000, () => { this.screenScroller = null })
    },
    clearTimeout() {
      this.connectionError = false
      clearTimeout(this.timeout)
      clearInterval(this.intervalCountdown)
      clearInterval(this.intervalConnectionError)
      this.countdown = 60
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.countdown = 60
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
      if (!this.intervalChangeScreen) {
        this.setIntervalChangeScreen()
      }
    },
    setIntervalCountdownConnectionError() {
      clearInterval(this.intervalConnectionError)
      this.countdownConnectionError = 10
      this.intervalConnectionError = setInterval(function () {
        this.countdownConnectionError = this.countdownConnectionError === 0 ? 0 : this.countdownConnectionError - 1
      }.bind(this), 1000)
    },
    async getTours() {
      if (this.countryOverride && this.filterWarehouse) {
        let startDate = this.moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
        let endDate = this.moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.fetches = {
          waiting: {
            filter_groups: [
              {
                filters: [
                  ['updated_at', 'bt', [startDate, endDate]],
                  ['status', 'eq', 'WAITING']
                ]
              }
            ],
            sort: [
              {
                key: 'updated_at',
                direction: 'desc'
              }
            ]
          },
          ready: {
            filter_groups: [
              {
                filters: [
                  ['updated_at', 'bt', [startDate, endDate]],
                  ['status', 'eq', 'READY'],
                  ['courier_id', 'eq', null]
                ]
              }
            ],
            sort: [
              {
                key: 'updated_at',
                direction: 'desc'
              }
            ]
          },
          confirmed: {
            filter_groups: [
              {
                filters: [
                  ['updated_at', 'bt', [startDate, endDate]],
                  ['status', 'eq', 'READY'],
                  ['courier_id', 'eq', null, 'true']
                ]
              }
            ],
            postSort: (a, b) => a.distanceToDestination - b.distanceToDestination
          },
          intransit: {
            filter_groups: [
              {
                filters: [
                  ['updated_at', 'bt', [startDate, endDate]],
                  ['status', 'eq', 'INTRANSIT']
                ]
              }
            ],
            postSort: (a, b) => (a.order > b.order ? -1 : 1)
          },
          finished: {
            filter_groups: [
              {
                filters: [
                  ['updated_at', 'bt', [this.moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), endDate]],
                  ['status', 'eq', 'FINISHED']
                ]
              }
            ],
            sort: [
              {
                key: 'finished_at',
                direction: 'desc'
              }
            ]
          }
        }
        this.statuses = Object.keys(this.fetches)
        this.working = true
        await this.checkPlace({id: this.filterWarehouse})
        this.$nextTick(async () => {
          if (this.theCheckedAddress.id) {
            this.filterWarehouseArea = this.theCheckedAddress.in_area.id
          }
          this.clearTimeout()
          let toursPromise = []

          this.statuses.forEach(async (item, i) => {
            toursPromise.push(this.fetchTours(item, this.fetches[item], item))
          })

          return await Promise.all(toursPromise)
            .then(responses => {
              this.tours = []
              for (const response of responses) {
                this.tours = this.tours.concat(response)
              }
              this.timeout = setTimeout(function () {
                this.getTours()
              }.bind(this), 60000)
              this.setIntervalCountdown()
            }, () => {
              this.$root.$children[0].$refs.simplert.justCloseSimplert()
              this.connectionError = true
              this.setIntervalCountdownConnectionError()
              this.timeout = setTimeout(function () {
                this.getTours()
              }.bind(this), 10000)
            })
            .finally(() => {
              this.working = false
              return true
            })
        })
      }
    },
    fetchTours(status, filters, visualStatus = null) {
      let params = {
        response_type: 'summary',
        filter_groups: [
          {
            filters: [
              ['area_id_from', 'eq', this.filterWarehouseArea],
              ['visits.place_id', 'eq', this.filterWarehouse]
            ]
          }
        ]
      }
      if (!this.$cookies.get('bypassCountry') || this.countryOverride) {
        params.filter_groups.push(
          {
            filters: [
              ['country_iso_code', 'eq', this.countryOverride]
            ]
          }
        )
      }
      params.filter_groups.push(filters.filter_groups[0])
      if (filters.sort) {
        params.sort = filters.sort
      }

      return this.$http.get(this.$appConfig.api.baseUrl + 'tours', {params: params})
        .then(response => {
          let tours = response.body.data.map(x => {
            x.visualStatus = visualStatus === 'ready' && x.status === 'WAITING' ? 'waiting' : visualStatus
            x.shippingsQty = Object.values(x.sizes).reduce((a, b) => a + b, 0)
            x.distanceToDestination = this.setDistanceToDestination(x)
            x.readableDistanceToDestination = this.distance(x.distanceToDestination, true)
            x.visits4Show = this.setVisits4Show(x.visits)
            x.completedRatio = x.visits4Show.filter(y => y.visited === 1).length / x.visits4Show.length
            x.completedPercentage = Math.floor(x.completedRatio * 100) + '%'
            const minutes = x.distanceToDestination / 1000 * 60 / this.averageSpeed
            x.eta = this.moment().startOf('day').add(minutes, 'minutes').format(minutes < 60 ? 'm' : 'hh:mm') + (minutes < 60 ? 'm' : 'h')
            if (x.status === 'INTRANSIT') {
              x.timeSinceStartRaw = x.started_at ? this.elapsedTimeRaw(x.started_at) : this.elapsedTimeRaw(x.created_at)
              x.timeSinceStart = x.started_at ? this.elapsedTime(x.started_at) : this.elapsedTime(x.created_at)
              x.order = x.completedRatio !== 0 ? x.timeSinceStartRaw / x.completedRatio : x.timeSinceStartRaw / 0.01
              x.order = x.order * x.shippingsQty
            }
            return x
          })
          if (filters.postSort) {
            tours = tours.sort(filters.postSort)
          }
          return tours
        })
    },
    setVisits4Show(visits) {
      let prevVisit
      let visits4Show = []
      visits.forEach(visit => {
        if (visit.type + '-' + visit.place_id !== prevVisit) {
          visit['shipping_ids'] = [visit.shipping_id]
          visits4Show.push(visit)
        } else {
          if (visit.visited === 1) {
            visits4Show[(visits4Show.length - 1)].visited = 1
          }
          visits4Show[(visits4Show.length - 1)].shipping_ids.push(visit.shipping_id)
        }
        prevVisit = visit.type + '-' + visit.place_id
      })
      return visits4Show
    },
    rowBg(tour) {
      let bg
      switch (tour.status) {
        case 'READY':
          if (tour.courier) {
            bg = 'bg-info-light'
          } else {
            bg = 'bg-dark-light'
          }
          break
        case 'INTRANSIT':
          bg = 'bg-warning-light'
          break
        case 'WAITING':
          bg = 'bg-secondary-light'
          break
        case 'FINISHED':
          bg = 'bg-success-light'
          break
        default:
          bg = 'bg-white'
      }
      return bg
    },
    isInViewport (elem) {
      let bounding = elem.getBoundingClientRect()
      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    },
    setDistanceToDestination(tour) {
      return tour.courier && tour.courier.courier_available && tour.courier.courier_available.tracking.length > 0 ? this.getDistance({lat: this.theCheckedAddress.lat, lng: this.theCheckedAddress.lng}, {lat: tour.courier.courier_available.tracking[0].lat, lng: tour.courier.courier_available.tracking[0].lng}) : null
    },
    setNewCountry() {
      if (this.countryOverride !== null) {
        this.fetchWarehouses(this.countryOverride)
        this.filterWarehouse = null
        this.shippings = []
      } else {
        this.warehouses = []
        this.filterWarehouse = null
      }
    }
  }
}
</script>

<style lang="scss">
.tours-control-monitor {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10000;
  overflow: auto;
  line-height: 1.3;
  .card {
    box-shadow: none !important;
  }
  .card-body {
    padding: 5px !important;
  }
}
#modalConfigMonitor___BV_modal_outer_ {
  z-index: 10040 !important
}
</style>
